export default "__VITE_ASSET__CW$$GVDB__"